exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 992px) {\n  .sidebar-mini.sidebar-collapse .brand-text,\n  .sidebar-mini.sidebar-collapse .user-text,\n  .sidebar-mini.sidebar-collapse .main-sidebar:hover .brand-text {\n    display: none;\n  }\n}\n\n.brand-text {\n  font-size: 20px;\n  font-family: 'Inter', sans-serif;\n  font-variant-numeric: tabular-nums;\n  color: #4365a7;\n  font-weight: 800;\n}\n", ""]);

// exports
